import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { useNavigate } from "react-router-dom";
import { useDataLayerValue } from "../../DataLayer/DataLayer";

import {
  createDrsInstance,
  updateDrsInstance,
} from "../../utils/ApiCalls/DrsInstance";
import { checkFields } from "../../utils/Validation/checkFields";

const DRSinstanceInput = ({ drsinatance }) => {
  const [name, setName] = useState("");
  const [instance, setInstance] = useState("");
  const [currency, setCurrency] = useState("");
  const [, dispatch] = useDataLayerValue();
  const [error, setError] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    if (drsinatance) {
      setName(drsinatance?.shipName);
      setInstance(drsinatance.instance);
      setCurrency(drsinatance?.currency);
    }
  }, [drsinatance]);


  const addDRSinstance = async (e) => {
    e.preventDefault();
    let added = false;
    let dataValues = {
      shipName: name,
      currency,
      instance,
    };

    let valid = checkFields(dataValues);
    if (valid) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: valid, type: "error" },
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      setError(valid);
    } else {
      setError();

      const values = {
       
        ...dataValues,
      };

      let data;
      if (drsinatance?.id) {
        data = await updateDrsInstance(drsinatance.id, values);
      } else {
        data = await createDrsInstance(values);
      }
      if (data?.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
        added = false;
      } else {
        added = true;
      }

      if (added && !drsinatance.id) {
        navigate("/website/loyalty/drs-instance");
      } else {
        navigate("/website/loyalty/drs-instance");
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: "Values updated", type: "success" },
        });
      }
    }
  };
  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addDRSinstance}>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Name</label>
                      <input
                        required
                        className="f_input"
                        type="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Instance</label>
                      <input
                        required
                        className="f_input"
                        type="text"
                        value={instance}
                        onChange={(e) => setInstance(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Currency</label>
                      <input
                        required
                        className="f_input"
                        type="text"
                        value={currency}
                        onChange={(e) => setCurrency(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-footer text-right">
                <button className="btn main_submit">
                  {drsinatance?.id ? "Update" : "Add"} DRS Instance
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default DRSinstanceInput;
